module.exports = __webpack_public_path__ + "img/1024-editor.dbf9535b.png";